import { DynamicRoute } from '../shared/navigation/dynamic-route';
import { SwitchAccountComponent } from './switch-account.component';
import { NeverShowRouteResolver } from '../shared/navigation/never-show-route-resolver';
import { PermissionLevel } from '../shared/permission/permission';

export const switchAccountRoutes: Array<DynamicRoute> = [
  {
    path: 'switch-account/:redirect',
    component: SwitchAccountComponent,
    data: {
      show: NeverShowRouteResolver,
      title: '',
      permissionLevel: PermissionLevel.MANAGER,
      type: []
    }
  }
];
